import React, { useEffect, useState } from 'react'
import { useSnackbar } from 'notistack'
import Button from "@mui/material/Button"
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded"
import PageHeading from "components/common/LayoutComponents/PageHeading"
import LoadingScreen from "components/common/LoadingScreen"
import { listExperts } from 'services/expert'
import { verifyResponse } from "utils/httpRequest"
import useExpertDialog from './ExpertDlg'
import ExpertTable from './ExpertTable'
import { StyledExpert } from './Expert.style'

const Expert = () => {
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const [experts, setExperts] = useState([])
  const { openDialog, dialog } = useExpertDialog({ onSubmit: () => load() })

  const load = async () => {
    setLoading(true)
    try {
      const resp = await listExperts()
      // Accept array or wrapped response
      const arr = Array.isArray(resp)
        ? resp
        : Array.isArray(resp?.data)
          ? resp.data
          : Array.isArray(resp?.data?.data)
            ? resp.data.data
            : []
      setExperts(arr)
      verifyResponse({ data: arr })
    } catch (e) {
      enqueueSnackbar('Failed to load experts', { variant: 'error' })
      setExperts([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    load()
  }, [])

  if (loading && experts.length === 0) {
    return <LoadingScreen />
  }

  // Default access control - can be enhanced with permission checks later
  const access = {
    editExpertAccess: true,
    deleteExpertAccess: true,
    toggleStatusExpertAccess: true,
  }

  return (
    <StyledExpert>
      <PageHeading>
        <div className="heading-copy">
          <h1 className="page-title">Expert Management</h1>
          <p className="page-subtitle">
            Manage featured experts, profile details, and related program links.
          </p>
        </div>
        <div className="actions">
          <Button
            className="new-expert-btn"
            variant="contained"
            size="medium"
            startIcon={<AddCircleOutlineRoundedIcon />}
            onClick={() => {
              openDialog(null)
            }}
          >
            Add Expert
          </Button>
        </div>
      </PageHeading>

      <div className="page-surface">
        <ExpertTable
          experts={experts}
          access={access}
          onEdit={(expert) => openDialog(expert.id)}
          onDelete={load}
          onToggleStatus={load}
        />
      </div>

      {dialog}
    </StyledExpert>
  )
}

export default Expert


